import { render, staticRenderFns } from "./image-editor.vue?vue&type=template&id=5669cd65&"
import script from "./image-editor.vue?vue&type=script&lang=ts&"
export * from "./image-editor.vue?vue&type=script&lang=ts&"
import style0 from "./image-editor.vue?vue&type=style&index=0&id=5669cd65&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports